import { Group } from "@mantine/core"
import { ColumnManager, ExportButton, ExportType } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { ExportCertificatesPdfRequestDto } from "~/gen/api"
import { useGetColumnManagerTranslations } from "~/hooks/table"
import { CertificatesFilters } from "~/pages/Brand/Certificates/components/CertificatesFilters"
import { CertificatesSearch } from "~/pages/Brand/Certificates/components/CertificatesSearch"
import { CertificatesSort } from "~/pages/Brand/Certificates/components/CertificatesSort"
import { useExportCertificatesPdfMutation } from "~/pages/Brand/Certificates/hooks/useExportCertificatesPdfMutation"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesTableHeaders = () => {
  const { t } = useTranslation()
  const columnManagerTranslations = useGetColumnManagerTranslations()
  const { rowSelection, table, isColumnManagerOpen, setIsColumnManagerOpen } =
    useCertificatesTableContext()

  const { mutate: exportCertificates, isPending: isCertificateExportLoading } =
    useExportCertificatesPdfMutation()

  if (!table) return null

  return (
    <Group justify="space-between">
      <Group>
        <CertificatesSearch />
        <CertificatesSort />
        <CertificatesFilters />
        <ColumnManager
          table={table}
          translations={columnManagerTranslations}
          isOpen={isColumnManagerOpen}
          setIsOpen={setIsColumnManagerOpen}
        />
      </Group>
      <ExportButton<ExportCertificatesPdfRequestDto>
        label={t("common:actionButtons.export")}
        exportOptions={[
          {
            type: ExportType.PDF,
            label: t("common:actionButtons.exportAsPdf"),
            isLoading: isCertificateExportLoading,
            exportFunction: (args) => exportCertificates({ data: args }),
            args: {
              certificateIds: Object.keys(rowSelection).filter(
                (row) => rowSelection[row]
              ),
            },
          },
        ]}
        count={Object.keys(rowSelection).length}
        disabled={Object.keys(rowSelection).length === 0}
      />
    </Group>
  )
}
